import { Trans } from "@lingui/react/macro";
import { LinkifiedText } from "@rakazo/chat-ui/web";
import { ChevronRight, Clock3 } from "lucide-react";
import { useState } from "react";

/** The original message remains intact; full text is mounted only when requested. */
export function RoutineRunDisclosure({
  text,
  quoteMessageId,
}: {
  text: string;
  quoteMessageId?: string;
}) {
  const [expanded, setExpanded] = useState(false);
  return (
    <details
      data-testid="routine-run-disclosure"
      onToggle={(event) => setExpanded(event.currentTarget.open)}
      className="wurkees-chat-text group/routine w-full min-w-0 rounded-xl border border-border bg-muted/40 text-foreground"
    >
      <summary className="flex cursor-pointer list-none items-center gap-2 rounded-xl px-3 py-2 text-sm leading-5 text-muted-foreground outline-none focus-visible:ring-2 focus-visible:ring-ring [&::-webkit-details-marker]:hidden">
        <Clock3 className="size-4 shrink-0" aria-hidden="true" />
        <span>
          <Trans>Routine run</Trans>
        </span>
        <ChevronRight
          className="size-3.5 shrink-0 transition-transform group-open/routine:rotate-90 motion-reduce:transition-none"
          aria-hidden="true"
        />
      </summary>
      {expanded ? (
        <div
          data-testid="routine-run-details"
          data-quote-message-id={quoteMessageId}
          className="max-h-96 overflow-y-auto whitespace-pre-wrap wrap-anywhere border-t border-border px-4 py-3 text-sm leading-5 text-muted-foreground"
          dir="auto"
        >
          <LinkifiedText>{text}</LinkifiedText>
        </div>
      ) : null}
    </details>
  );
}
